export enum EEnvironment {
  LOCALDEV = "LOCAL",
  DEV = "DEVELOPMENT",
  QA = "QA",
  PROD = "PRODUCTION",
}
